import {DialogTitleMrGreenBox} from "./dialog-title.mrgreen.box";

export const DialogTitleMrGreenCisBox = DialogTitleMrGreenBox;